export default __webpack_public_path__ + "static/DTMC-3613b60d9f05c927b814cee70f1b4343.png";